module.exports = "<svg viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" stroke=\"#FFFFFF\" fill-rule=\"evenodd\" opacity=\".7\">\n        <path d=\"M0.5,12.5a12,12 0 1,0 24,0a12,12 0 1,0 -24,0\" />\n        <path\n            d=\"M17.8 9.75L16.56 11 14 8.44l1.25-1.24c.26-.27.7-.27.96 0l1.6 1.6c.26.25.26.7 0 .95zM13.73 9L16 11.27 9.29 18H7v-2.28L13.73 9z\"\n        />\n    </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./public/img/pen-circle.svg
// module id = zZwA
// module chunks = 5